module.exports = __webpack_public_path__ + "static/media/asist.carretera.7826630b.png";